import { del, post } from '../client';

export const deviceTokensApi = {
  register: ({ token, platform = 'web', deviceId, appVersion }) =>
    post('/device-tokens', {
      token,
      platform,
      ...(deviceId ? { deviceId } : {}),
      ...(appVersion ? { appVersion } : {}),
    }),
  unregister: (token) => del('/device-tokens', { data: { token } }),
  sendTest: (body = {}) => post('/device-tokens/test', body),
};
